import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DatasetEffects } from './dataset/dataset.effects';
import * as fromDataset from './dataset/dataset.reducer';
import * as fromDatasets from './datasets/datasets.reducer';
import { DatasetsEffects } from './datasets/datasets.effects';
import { GoogleSheetEffects } from './google-sheet/google-sheet.effects';
import { SchedulesEffects } from './schedules/schedules.effects';
import { schedulesFeature } from './schedules/schedules.reducer';
import * as fromGoogleSheetIngest from './google-sheet/google-sheet.reducer';
import { DatasetFacade, GoogleSheetFacade } from '@mode/dataset/contract';
import { GoogleSheetFacadeService } from './google-sheet/google-sheet-facade.service';
import { DatasetService } from './dataset/dataset.service';
import { CellExportFacade } from '@mode/notebooks/contract';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { CellExportService } from '@mode/notebooks/domain';
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromDataset.datasetFeatureKey, fromDataset.reducer),
    StoreModule.forFeature(fromDatasets.datasetsFeatureKey, fromDatasets.reducer),
    StoreModule.forFeature(schedulesFeature),
    StoreModule.forFeature(
      fromGoogleSheetIngest.GOOGLE_SHEET_DATASET_FEATURE_KEY,
      fromGoogleSheetIngest.googleSheetIngestReducer
    ),
    EffectsModule.forFeature([DatasetEffects, DatasetsEffects, SchedulesEffects, GoogleSheetEffects]),
  ],
  providers: [
    { provide: GoogleSheetFacade, useClass: GoogleSheetFacadeService },
    { provide: DatasetFacade, useClass: DatasetService },
    { provide: CellExportFacade, useClass: CellExportService },
  ],
})
export class DatasetDomainModule {}
